<ul class="nav nav-tabs nav-tabs-cards" style="margin-top:15px" [id]="props.key" role="tablist">
  <li *ngFor="let tab of tabs; index as i" class="nav-item">
    <a [ngClass]="{'nav-link': true , active: tab.active, disabled: tab.disabled}" [id]="props['key']+'-tab'+(i+1)"
      data-bs-toggle="tab" [href]="setHref(i)" role="tab" [attr.aria-controls]="props['key'] + '-content'+ (i+1)"
      aria-selected="false" (click)="onClick(tab.props)">
      {{ tab.props.label }}</a>
  </li>
  <li class="nav-item-filler"></li>
</ul>
<div *ngIf="props['type']!='remote'" class="tab-content" [id]="props['key'] + '-content'">
  <div *ngFor="let tab of tabs; index as i" [ngClass]="{'tab-pane p-4 fade': true , 'show active': tab.active}"
    [id]="props['key'] + '-content'+ (i+1)" role="tabpanel" [attr.aria-labelledby]="props['key']+'-tab'+(i+1)">{{
    tab.props.content }}</div>
</div>